import styled from "styled-components";

const BatchesPageStyled = styled.div`

`

export default BatchesPageStyled;